import axios from "axios";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/account`;

export const deleteUserEntityPermission = async (
  accountId: number,
  userId: number,
  entityId: number
): Promise<void> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}"
  );

  await axios.put(
    `${BASE_URL}/${accountId}/users/${userId}/entity-permissions/${entityId}/deactivate`,
    {},
    {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    }
  );
};